// apps/web/src/components/ui/fieldset.tsx
//
// Phase 8 in-repo custom primitive — no shadcn registry block exists for fieldset.
// Mirrors the Phase 6 pill.tsx pattern (in-repo custom). Native <fieldset> +
// <legend> for WCAG AA screen-reader semantics on grouped form controls.
//
// Visual contract: UI-SPEC §"Fieldset component spec" (lines 466-491).
import type * as React from "react";
import { cn } from "@/lib/utils";

export interface FieldsetProps extends React.FieldsetHTMLAttributes<HTMLFieldSetElement> {
  legend: string;
  children: React.ReactNode;
}

export function Fieldset({
  legend,
  className,
  children,
  ...props
}: FieldsetProps): React.ReactElement {
  return (
    <fieldset
      className={cn("flex flex-col gap-3 rounded-lg border border-input p-4", className)}
      {...props}
    >
      <legend className="px-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {legend}
      </legend>
      {children}
    </fieldset>
  );
}
Fieldset.displayName = "Fieldset";
